module.exports = __webpack_public_path__ + "static/media/task_ok.bbafe751.svg";